import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import "./ApplyNow.css";
import Seo from "../components/Seo";

const initialFormData = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  pincode: "",
  employment_status: "",
  loan_type: "",
  bank: "",
  income: "",
  loan_amount: "",
  questions: "",
};

const loanOptions = [
  {
    value: "Home Loan",
    labelEn: "Home Loan",
    labelMr: "गृहकर्ज",
    icon: "bi bi-house-door",
  },
  {
    value: "Home Loan Balance Transfer",
    labelEn: "Home Loan Balance Transfer",
    labelMr: "गृहकर्ज बॅलन्स ट्रान्सफर",
    icon: "bi bi-arrow-repeat",
  },
  {
    value: "Loan Against Property",
    labelEn: "Loan Against Property",
    labelMr: "मालमत्तेवर कर्ज",
    icon: "bi bi-buildings",
  },
  {
    value: "Commercial Loan",
    labelEn: "Commercial Loan",
    labelMr: "व्यावसायिक मालमत्ता कर्ज",
    icon: "bi bi-building",
  },
  {
    value: "Personal Loan",
    labelEn: "Personal Loan",
    labelMr: "वैयक्तिक कर्ज",
    icon: "bi bi-person-check",
  },
  {
    value: "Business Loan",
    labelEn: "Business Loan",
    labelMr: "व्यवसाय कर्ज",
    icon: "bi bi-briefcase",
  },
  {
    value: "Education Loan",
    labelEn: "Education Loan",
    labelMr: "शिक्षण कर्ज",
    icon: "bi bi-mortarboard",
  },
  {
    value: "Car Loan",
    labelEn: "Car Loan",
    labelMr: "कार कर्ज",
    icon: "bi bi-car-front",
  },
];

const bankOptions = [
  "State Bank of India",
  "Bank of Maharashtra",
  "Bank of India",
  "Central Bank of India",
  "Bank of Baroda",
  "Indian Overseas Bank",
  "IDBI Bank",
  "HDFC Bank",
  "ICICI Bank",
  "Axis Bank",
  "Kotak Mahindra Bank",
  "Standard Chartered Bank",
  "IDFC FIRST Bank",
  "Other / Need Recommendation",
];

const employmentOptions = [
  {
    value: "Salaried",
    labelEn: "Salaried",
    labelMr: "नोकरी करणारे",
  },
  {
    value: "Self-Employed",
    labelEn: "Self-Employed",
    labelMr: "स्वयंरोजगार / व्यवसायिक",
  },
  {
    value: "Professional",
    labelEn: "Professional",
    labelMr: "व्यावसायिक तज्ज्ञ",
  },
];

const translations = {
  en: {
    seoTitle: "Apply for a Loan Online | MONAYRA",
    seoDescription:
      "Apply online for a home loan, Loan Against Property, personal loan, business loan, car loan or education loan with MONAYRA (OPC) PRIVATE LIMITED.",

    eyebrow: "Online Loan Application",
    heading: "Start your loan journey with MONAYRA",
    subheading:
      "Share your basic details and loan requirement. Our team will review your enquiry and contact you regarding the next steps.",

    languageButton: "मराठीत वाचा",

    personalSection: "Personal Information",
    personalDescription:
      "Enter your name and contact details exactly as you use them for official communication.",

    loanSection: "Loan Requirement",
    loanDescription:
      "Choose your loan product, employment profile and preferred lender.",

    financialSection: "Financial Information",
    financialDescription:
      "Provide approximate income and loan requirement details.",

    additionalSection: "Additional Information",
    additionalDescription:
      "Share any specific requirement or question for our team.",

    labels: {
      first_name: "First Name",
      last_name: "Last Name",
      email: "Email Address",
      phone: "Mobile Number",
      pincode: "PIN Code",
      employment_status: "Employment Status",
      loan_type: "Loan Type",
      bank: "Preferred Bank",
      income: "Monthly Net Income",
      loan_amount: "Required Loan Amount",
      questions: "Questions or Additional Details",
    },

    placeholders: {
      first_name: "Enter first name",
      last_name: "Enter last name",
      email: "Enter email address",
      phone: "Enter 10-digit mobile number",
      pincode: "Enter 6-digit PIN code",
      employment_status: "Select employment status",
      loan_type: "Select loan type",
      bank: "Select preferred bank",
      income: "Enter monthly net income",
      loan_amount: "Enter required loan amount",
      questions:
        "Mention property location, current loan details, preferred callback time or any other requirement.",
    },

    submit: "Submit Loan Application",
    submitting: "Submitting Application...",

    required: "Required",
    optional: "Optional",

    privacy:
      "By submitting this form, you agree that MONAYRA (OPC) PRIVATE LIMITED may contact you regarding your loan enquiry.",

    success:
      "Your application has been submitted successfully. Our team will contact you regarding the next steps.",

    genericError:
      "Something went wrong while submitting the form. Please try again.",

    serverError:
      "The server could not be reached. Please try again later.",

    errors: {
      first_name: "Please enter your first name.",
      last_name: "Please enter your last name.",
      email: "Please enter a valid email address.",
      phone: "Please enter a valid 10-digit mobile number.",
      pincode: "Please enter a valid 6-digit PIN code.",
      employment_status: "Please select your employment status.",
      loan_type: "Please select a loan type.",
      bank: "Please select a bank or recommendation option.",
      income: "Please enter a valid monthly income.",
      loan_amount: "Please enter a valid required loan amount.",
    },

    steps: {
      details: "Your Details",
      requirement: "Loan Requirement",
      financial: "Financial Profile",
    },

    helpTitle: "Need assistance before applying?",
    helpText:
      "Our team can guide you regarding eligibility, documents, loan products and lender options.",
    contactButton: "Contact Our Team",

    benefits: [
      "Multiple loan products",
      "Selected lender comparison",
      "Document assistance",
      "Application coordination",
    ],

    disclaimer:
      "Submitting this form does not guarantee loan approval. Final eligibility, interest rate, loan amount, tenure, charges and approval are determined by the selected lender.",
  },

  mr: {
    seoTitle: "कर्जासाठी ऑनलाइन अर्ज करा | MONAYRA",
    seoDescription:
      "MONAYRA (OPC) PRIVATE LIMITED कडून गृहकर्ज, मालमत्तेवर कर्ज, वैयक्तिक कर्ज, व्यवसाय कर्ज, कार कर्ज किंवा शिक्षण कर्जासाठी ऑनलाइन अर्ज करा.",

    eyebrow: "ऑनलाइन कर्ज अर्ज",
    heading: "MONAYRA सोबत तुमचा कर्ज प्रवास सुरू करा",
    subheading:
      "तुमची प्राथमिक माहिती आणि कर्जाची गरज भरा. आमची टीम तुमचा अर्ज तपासून पुढील प्रक्रियेसाठी संपर्क करेल.",

    languageButton: "Read in English",

    personalSection: "वैयक्तिक माहिती",
    personalDescription:
      "अधिकृत संपर्कासाठी वापरत असलेले नाव आणि संपर्क तपशील भरा.",

    loanSection: "कर्जाची गरज",
    loanDescription:
      "कर्जाचा प्रकार, रोजगार स्थिती आणि पसंतीची बँक निवडा.",

    financialSection: "आर्थिक माहिती",
    financialDescription:
      "अंदाजे मासिक उत्पन्न आणि आवश्यक कर्जाची रक्कम भरा.",

    additionalSection: "अतिरिक्त माहिती",
    additionalDescription:
      "तुमची विशेष गरज किंवा प्रश्न आमच्या टीमसाठी लिहा.",

    labels: {
      first_name: "पहिले नाव",
      last_name: "आडनाव",
      email: "ईमेल पत्ता",
      phone: "मोबाईल नंबर",
      pincode: "पिन कोड",
      employment_status: "रोजगार स्थिती",
      loan_type: "कर्जाचा प्रकार",
      bank: "पसंतीची बँक",
      income: "मासिक निव्वळ उत्पन्न",
      loan_amount: "आवश्यक कर्जाची रक्कम",
      questions: "प्रश्न किंवा अतिरिक्त माहिती",
    },

    placeholders: {
      first_name: "पहिले नाव भरा",
      last_name: "आडनाव भरा",
      email: "ईमेल पत्ता भरा",
      phone: "10 अंकी मोबाईल नंबर भरा",
      pincode: "6 अंकी पिन कोड भरा",
      employment_status: "रोजगार स्थिती निवडा",
      loan_type: "कर्जाचा प्रकार निवडा",
      bank: "पसंतीची बँक निवडा",
      income: "मासिक निव्वळ उत्पन्न भरा",
      loan_amount: "आवश्यक कर्जाची रक्कम भरा",
      questions:
        "मालमत्तेचे ठिकाण, सध्याच्या कर्जाची माहिती, संपर्काची वेळ किंवा इतर गरज लिहा.",
    },

    submit: "कर्ज अर्ज सबमिट करा",
    submitting: "अर्ज सबमिट होत आहे...",

    required: "आवश्यक",
    optional: "ऐच्छिक",

    privacy:
      "हा फॉर्म सबमिट करून तुम्ही MONAYRA (OPC) PRIVATE LIMITED ला तुमच्या कर्ज चौकशीसाठी संपर्क करण्याची परवानगी देता.",

    success:
      "तुमचा अर्ज यशस्वीरित्या सबमिट झाला आहे. पुढील प्रक्रियेसाठी आमची टीम तुमच्याशी संपर्क करेल.",

    genericError:
      "फॉर्म सबमिट करताना समस्या आली. कृपया पुन्हा प्रयत्न करा.",

    serverError:
      "सर्व्हरशी संपर्क होऊ शकला नाही. कृपया नंतर पुन्हा प्रयत्न करा.",

    errors: {
      first_name: "कृपया पहिले नाव भरा.",
      last_name: "कृपया आडनाव भरा.",
      email: "कृपया योग्य ईमेल पत्ता भरा.",
      phone: "कृपया योग्य 10 अंकी मोबाईल नंबर भरा.",
      pincode: "कृपया योग्य 6 अंकी पिन कोड भरा.",
      employment_status: "कृपया रोजगार स्थिती निवडा.",
      loan_type: "कृपया कर्जाचा प्रकार निवडा.",
      bank: "कृपया बँक किंवा शिफारस पर्याय निवडा.",
      income: "कृपया योग्य मासिक उत्पन्न भरा.",
      loan_amount: "कृपया योग्य कर्जाची रक्कम भरा.",
    },

    steps: {
      details: "तुमची माहिती",
      requirement: "कर्जाची गरज",
      financial: "आर्थिक माहिती",
    },

    helpTitle: "अर्ज करण्यापूर्वी मदत हवी आहे?",
    helpText:
      "आमची टीम पात्रता, कागदपत्रे, कर्ज प्रकार आणि बँक पर्यायांबाबत मार्गदर्शन करू शकते.",
    contactButton: "आमच्या टीमशी संपर्क करा",

    benefits: [
      "अनेक कर्ज प्रकार",
      "निवडक बँक तुलना",
      "कागदपत्र मार्गदर्शन",
      "अर्ज प्रक्रियेसाठी मदत",
    ],

    disclaimer:
      "हा फॉर्म सबमिट केल्याने कर्ज मंजुरीची हमी मिळत नाही. अंतिम पात्रता, व्याजदर, कर्ज रक्कम, कालावधी, शुल्क आणि मंजुरी निवडलेल्या बँकेद्वारे ठरवली जाते.",
  },
};

const formatIndianNumber = (value) => {
  if (value === "" || value === null || value === undefined) {
    return "";
  }

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return "";
  }

  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
  }).format(numericValue);
};

const getRawNumericValue = (value) =>
  value.replace(/[^\d]/g, "").replace(/^0+(?=\d)/, "");

const ANF = () => {
  const [language, setLanguage] = useState("en");
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const lang = translations[language];

  const completedSections = useMemo(() => {
    let completed = 0;

    const personalComplete =
      formData.first_name.trim() &&
      formData.last_name.trim() &&
      formData.email.trim() &&
      formData.phone.trim() &&
      formData.pincode.trim();

    const loanComplete =
      formData.employment_status &&
      formData.loan_type &&
      formData.bank;

    const financialComplete =
      Number(formData.income) > 0 &&
      Number(formData.loan_amount) > 0;

    if (personalComplete) completed += 1;
    if (loanComplete) completed += 1;
    if (financialComplete) completed += 1;

    return completed;
  }, [formData]);

  const progressPercentage = Math.round(
    (completedSections / 3) * 100
  );

  const clearFieldError = (fieldName) => {
    setErrors((currentErrors) => {
      if (!currentErrors[fieldName]) {
        return currentErrors;
      }

      const updatedErrors = { ...currentErrors };
      delete updatedErrors[fieldName];

      return updatedErrors;
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((currentData) => ({
      ...currentData,
      [name]: value,
    }));

    clearFieldError(name);
    setSuccessMessage("");
    setErrorMessage("");
  };

  const handleDigitsOnlyChange = (
    fieldName,
    value,
    maxLength
  ) => {
    const cleanedValue = value.replace(/\D/g, "").slice(0, maxLength);

    setFormData((currentData) => ({
      ...currentData,
      [fieldName]: cleanedValue,
    }));

    clearFieldError(fieldName);
    setSuccessMessage("");
    setErrorMessage("");
  };

  const handleCurrencyChange = (fieldName, value) => {
    const rawValue = getRawNumericValue(value);

    setFormData((currentData) => ({
      ...currentData,
      [fieldName]: rawValue,
    }));

    clearFieldError(fieldName);
    setSuccessMessage("");
    setErrorMessage("");
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.first_name.trim()) {
      newErrors.first_name = lang.errors.first_name;
    }

    if (!formData.last_name.trim()) {
      newErrors.last_name = lang.errors.last_name;
    }

    if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
        formData.email.trim()
      )
    ) {
      newErrors.email = lang.errors.email;
    }

    if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      newErrors.phone = lang.errors.phone;
    }

    if (!/^\d{6}$/.test(formData.pincode)) {
      newErrors.pincode = lang.errors.pincode;
    }

    if (!formData.employment_status) {
      newErrors.employment_status =
        lang.errors.employment_status;
    }

    if (!formData.loan_type) {
      newErrors.loan_type = lang.errors.loan_type;
    }

    if (!formData.bank) {
      newErrors.bank = lang.errors.bank;
    }

    if (
      !formData.income ||
      Number(formData.income) <= 0
    ) {
      newErrors.income = lang.errors.income;
    }

    if (
      !formData.loan_amount ||
      Number(formData.loan_amount) <= 0
    ) {
      newErrors.loan_amount = lang.errors.loan_amount;
    }

    setErrors(newErrors);

    const firstErrorField = Object.keys(newErrors)[0];

    if (firstErrorField) {
      window.requestAnimationFrame(() => {
        const element = document.getElementById(
          `anf-${firstErrorField}`
        );

        element?.focus();
        element?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      });
    }

    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setErrors({});
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setSuccessMessage("");
    setErrorMessage("");

    if (!validate()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const formBody = new FormData();

      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch(
        "https://monayra.com/api/submit.php",
        {
          method: "POST",
          body: formBody,
        }
      );

      const responseText = await response.text();

      const normalizedResponse = responseText
        .trim()
        .toLowerCase();

      const submissionSucceeded =
        response.ok &&
        (
          normalizedResponse.includes("success") ||
          normalizedResponse.includes("submitted") ||
          normalizedResponse.includes("true")
        );

      if (!submissionSucceeded) {
        throw new Error(
          responseText || "Submission was not accepted."
        );
      }

      setSuccessMessage(lang.success);
      setErrorMessage("");
      resetForm();

      window.requestAnimationFrame(() => {
        document
          .querySelector(".anf-status-message")
          ?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
      });
    } catch (error) {
      console.error("Loan application submission error:", error);

      const isNetworkError =
        error instanceof TypeError &&
        error.message.toLowerCase().includes("fetch");

      setErrorMessage(
        isNetworkError
          ? lang.serverError
          : lang.genericError
      );

      setSuccessMessage("");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Seo
        title={lang.seoTitle}
        description={lang.seoDescription}
        keywords="apply loan online, home loan application, Loan Against Property application, personal loan application, business loan application"
        canonical="https://www.mortbuzz.in/apply-now"
      />

      <main className="monayra-apply-now-page">
        <section className="anf-hero-section">
          <div className="anf-hero-overlay"></div>

          <div
            className="anf-glow anf-glow-left"
            aria-hidden="true"
          ></div>

          <div
            className="anf-glow anf-glow-right"
            aria-hidden="true"
          ></div>

          <div className="anf-page-container anf-hero-grid">
            <div className="anf-hero-content">
              <span className="anf-eyebrow">
                {lang.eyebrow}
              </span>

              <h1>{lang.heading}</h1>

              <p>{lang.subheading}</p>

              <div className="anf-hero-benefits">
                {lang.benefits.map((benefit) => (
                  <div key={benefit}>
                    <span>
                      <i className="bi bi-check-lg"></i>
                    </span>

                    {benefit}
                  </div>
                ))}
              </div>
            </div>

            <aside className="anf-hero-summary">
              <span className="anf-hero-summary-icon">
                <i className="bi bi-file-earmark-text"></i>
              </span>

              <span className="anf-card-eyebrow">
                {language === "en"
                  ? "Application Progress"
                  : "अर्जाची प्रगती"}
              </span>

              <h2>
                {completedSections} / 3{" "}
                {language === "en"
                  ? "sections completed"
                  : "विभाग पूर्ण"}
              </h2>

              <div className="anf-progress-track">
                <span
                  style={{
                    width: `${progressPercentage}%`,
                  }}
                ></span>
              </div>

              <div className="anf-progress-steps">
                <div
                  className={
                    completedSections >= 1 ? "complete" : ""
                  }
                >
                  <span>
                    {completedSections >= 1 ? (
                      <i className="bi bi-check-lg"></i>
                    ) : (
                      "1"
                    )}
                  </span>

                  {lang.steps.details}
                </div>

                <div
                  className={
                    completedSections >= 2 ? "complete" : ""
                  }
                >
                  <span>
                    {completedSections >= 2 ? (
                      <i className="bi bi-check-lg"></i>
                    ) : (
                      "2"
                    )}
                  </span>

                  {lang.steps.requirement}
                </div>

                <div
                  className={
                    completedSections >= 3 ? "complete" : ""
                  }
                >
                  <span>
                    {completedSections >= 3 ? (
                      <i className="bi bi-check-lg"></i>
                    ) : (
                      "3"
                    )}
                  </span>

                  {lang.steps.financial}
                </div>
              </div>
            </aside>
          </div>
        </section>

        <section className="anf-form-section">
          <div className="anf-page-container">
            <div className="anf-form-toolbar">
              <div>
                <span className="anf-eyebrow">
                  {language === "en"
                    ? "Application Form"
                    : "अर्ज फॉर्म"}
                </span>

                <h2>
                  {language === "en"
                    ? "Enter your loan application details"
                    : "तुमच्या कर्ज अर्जाची माहिती भरा"}
                </h2>
              </div>

              <button
                type="button"
                className="anf-language-toggle"
                onClick={() =>
                  setLanguage((currentLanguage) =>
                    currentLanguage === "en" ? "mr" : "en"
                  )
                }
              >
                <i className="bi bi-translate"></i>
                {lang.languageButton}
              </button>
            </div>

            <div className="anf-form-layout">
              <form
                className="anf-application-form"
                onSubmit={handleSubmit}
                noValidate
              >
                <section className="anf-form-card">
                  <div className="anf-form-card-heading">
                    <span>
                      <i className="bi bi-person-vcard"></i>
                    </span>

                    <div>
                      <h3>{lang.personalSection}</h3>
                      <p>{lang.personalDescription}</p>
                    </div>

                    <small>{lang.required}</small>
                  </div>

                  <div className="anf-fields-grid anf-fields-grid-two">
                    <div
                      className={`anf-field ${
                        errors.first_name ? "has-error" : ""
                      }`}
                    >
                      <label htmlFor="anf-first_name">
                        {lang.labels.first_name}
                        <span>*</span>
                      </label>

                      <div className="anf-input-wrapper">
                        <i className="bi bi-person"></i>

                        <input
                          id="anf-first_name"
                          type="text"
                          name="first_name"
                          value={formData.first_name}
                          onChange={handleChange}
                          placeholder={lang.placeholders.first_name}
                          autoComplete="given-name"
                          maxLength="60"
                        />
                      </div>

                      {errors.first_name && (
                        <span className="anf-field-error">
                          <i className="bi bi-exclamation-circle"></i>
                          {errors.first_name}
                        </span>
                      )}
                    </div>

                    <div
                      className={`anf-field ${
                        errors.last_name ? "has-error" : ""
                      }`}
                    >
                      <label htmlFor="anf-last_name">
                        {lang.labels.last_name}
                        <span>*</span>
                      </label>

                      <div className="anf-input-wrapper">
                        <i className="bi bi-person"></i>

                        <input
                          id="anf-last_name"
                          type="text"
                          name="last_name"
                          value={formData.last_name}
                          onChange={handleChange}
                          placeholder={lang.placeholders.last_name}
                          autoComplete="family-name"
                          maxLength="60"
                        />
                      </div>

                      {errors.last_name && (
                        <span className="anf-field-error">
                          <i className="bi bi-exclamation-circle"></i>
                          {errors.last_name}
                        </span>
                      )}
                    </div>

                    <div
                      className={`anf-field ${
                        errors.email ? "has-error" : ""
                      }`}
                    >
                      <label htmlFor="anf-email">
                        {lang.labels.email}
                        <span>*</span>
                      </label>

                      <div className="anf-input-wrapper">
                        <i className="bi bi-envelope"></i>

                        <input
                          id="anf-email"
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder={lang.placeholders.email}
                          autoComplete="email"
                          maxLength="120"
                        />
                      </div>

                      {errors.email && (
                        <span className="anf-field-error">
                          <i className="bi bi-exclamation-circle"></i>
                          {errors.email}
                        </span>
                      )}
                    </div>

                    <div
                      className={`anf-field ${
                        errors.phone ? "has-error" : ""
                      }`}
                    >
                      <label htmlFor="anf-phone">
                        {lang.labels.phone}
                        <span>*</span>
                      </label>

                      <div className="anf-input-wrapper anf-phone-wrapper">
                        <span className="anf-country-code">
                          +91
                        </span>

                        <input
                          id="anf-phone"
                          type="tel"
                          name="phone"
                          inputMode="numeric"
                          value={formData.phone}
                          onChange={(event) =>
                            handleDigitsOnlyChange(
                              "phone",
                              event.target.value,
                              10
                            )
                          }
                          placeholder={lang.placeholders.phone}
                          autoComplete="tel"
                        />
                      </div>

                      {errors.phone && (
                        <span className="anf-field-error">
                          <i className="bi bi-exclamation-circle"></i>
                          {errors.phone}
                        </span>
                      )}
                    </div>

                    <div
                      className={`anf-field ${
                        errors.pincode ? "has-error" : ""
                      }`}
                    >
                      <label htmlFor="anf-pincode">
                        {lang.labels.pincode}
                        <span>*</span>
                      </label>

                      <div className="anf-input-wrapper">
                        <i className="bi bi-geo-alt"></i>

                        <input
                          id="anf-pincode"
                          type="tel"
                          name="pincode"
                          inputMode="numeric"
                          value={formData.pincode}
                          onChange={(event) =>
                            handleDigitsOnlyChange(
                              "pincode",
                              event.target.value,
                              6
                            )
                          }
                          placeholder={lang.placeholders.pincode}
                          autoComplete="postal-code"
                        />
                      </div>

                      {errors.pincode && (
                        <span className="anf-field-error">
                          <i className="bi bi-exclamation-circle"></i>
                          {errors.pincode}
                        </span>
                      )}
                    </div>
                  </div>
                </section>

                <section className="anf-form-card">
                  <div className="anf-form-card-heading">
                    <span>
                      <i className="bi bi-bank"></i>
                    </span>

                    <div>
                      <h3>{lang.loanSection}</h3>
                      <p>{lang.loanDescription}</p>
                    </div>

                    <small>{lang.required}</small>
                  </div>

                  <div className="anf-loan-options-grid">
                    {loanOptions.map((loan) => {
                      const isSelected =
                        formData.loan_type === loan.value;

                      return (
                        <button
                          type="button"
                          key={loan.value}
                          className={
                            isSelected ? "selected" : ""
                          }
                          onClick={() => {
                            setFormData((currentData) => ({
                              ...currentData,
                              loan_type: loan.value,
                            }));

                            clearFieldError("loan_type");
                          }}
                        >
                          <span>
                            <i className={loan.icon}></i>
                          </span>

                          <strong>
                            {language === "en"
                              ? loan.labelEn
                              : loan.labelMr}
                          </strong>

                          <i
                            className={
                              isSelected
                                ? "bi bi-check-circle-fill"
                                : "bi bi-circle"
                            }
                          ></i>
                        </button>
                      );
                    })}
                  </div>

                  {errors.loan_type && (
                    <span className="anf-field-error anf-group-error">
                      <i className="bi bi-exclamation-circle"></i>
                      {errors.loan_type}
                    </span>
                  )}

                  <input
                    type="hidden"
                    name="loan_type"
                    value={formData.loan_type}
                  />

                  <div className="anf-fields-grid anf-fields-grid-two anf-fields-spacing">
                    <div
                      className={`anf-field ${
                        errors.employment_status
                          ? "has-error"
                          : ""
                      }`}
                    >
                      <label htmlFor="anf-employment_status">
                        {lang.labels.employment_status}
                        <span>*</span>
                      </label>

                      <div className="anf-input-wrapper">
                        <i className="bi bi-briefcase"></i>

                        <select
                          id="anf-employment_status"
                          name="employment_status"
                          value={formData.employment_status}
                          onChange={handleChange}
                        >
                          <option value="">
                            {
                              lang.placeholders
                                .employment_status
                            }
                          </option>

                          {employmentOptions.map((option) => (
                            <option
                              value={option.value}
                              key={option.value}
                            >
                              {language === "en"
                                ? option.labelEn
                                : option.labelMr}
                            </option>
                          ))}
                        </select>

                        <i className="bi bi-chevron-down anf-select-arrow"></i>
                      </div>

                      {errors.employment_status && (
                        <span className="anf-field-error">
                          <i className="bi bi-exclamation-circle"></i>
                          {errors.employment_status}
                        </span>
                      )}
                    </div>

                    <div
                      className={`anf-field ${
                        errors.bank ? "has-error" : ""
                      }`}
                    >
                      <label htmlFor="anf-bank">
                        {lang.labels.bank}
                        <span>*</span>
                      </label>

                      <div className="anf-input-wrapper">
                        <i className="bi bi-building"></i>

                        <select
                          id="anf-bank"
                          name="bank"
                          value={formData.bank}
                          onChange={handleChange}
                        >
                          <option value="">
                            {lang.placeholders.bank}
                          </option>

                          {bankOptions.map((bank) => (
                            <option value={bank} key={bank}>
                              {bank}
                            </option>
                          ))}
                        </select>

                        <i className="bi bi-chevron-down anf-select-arrow"></i>
                      </div>

                      {errors.bank && (
                        <span className="anf-field-error">
                          <i className="bi bi-exclamation-circle"></i>
                          {errors.bank}
                        </span>
                      )}
                    </div>
                  </div>
                </section>

                <section className="anf-form-card">
                  <div className="anf-form-card-heading">
                    <span>
                      <i className="bi bi-cash-stack"></i>
                    </span>

                    <div>
                      <h3>{lang.financialSection}</h3>
                      <p>{lang.financialDescription}</p>
                    </div>

                    <small>{lang.required}</small>
                  </div>

                  <div className="anf-fields-grid anf-fields-grid-two">
                    <div
                      className={`anf-field ${
                        errors.income ? "has-error" : ""
                      }`}
                    >
                      <label htmlFor="anf-income">
                        {lang.labels.income}
                        <span>*</span>
                      </label>

                      <div className="anf-input-wrapper anf-currency-wrapper">
                        <span className="anf-currency-symbol">
                          ₹
                        </span>

                        <input
                          id="anf-income"
                          type="text"
                          name="income"
                          inputMode="numeric"
                          value={formatIndianNumber(
                            formData.income
                          )}
                          onChange={(event) =>
                            handleCurrencyChange(
                              "income",
                              event.target.value
                            )
                          }
                          placeholder={lang.placeholders.income}
                          autoComplete="off"
                        />
                      </div>

                      {errors.income && (
                        <span className="anf-field-error">
                          <i className="bi bi-exclamation-circle"></i>
                          {errors.income}
                        </span>
                      )}
                    </div>

                    <div
                      className={`anf-field ${
                        errors.loan_amount ? "has-error" : ""
                      }`}
                    >
                      <label htmlFor="anf-loan_amount">
                        {lang.labels.loan_amount}
                        <span>*</span>
                      </label>

                      <div className="anf-input-wrapper anf-currency-wrapper">
                        <span className="anf-currency-symbol">
                          ₹
                        </span>

                        <input
                          id="anf-loan_amount"
                          type="text"
                          name="loan_amount"
                          inputMode="numeric"
                          value={formatIndianNumber(
                            formData.loan_amount
                          )}
                          onChange={(event) =>
                            handleCurrencyChange(
                              "loan_amount",
                              event.target.value
                            )
                          }
                          placeholder={
                            lang.placeholders.loan_amount
                          }
                          autoComplete="off"
                        />
                      </div>

                      {errors.loan_amount && (
                        <span className="anf-field-error">
                          <i className="bi bi-exclamation-circle"></i>
                          {errors.loan_amount}
                        </span>
                      )}
                    </div>
                  </div>
                </section>

                <section className="anf-form-card">
                  <div className="anf-form-card-heading">
                    <span>
                      <i className="bi bi-chat-left-text"></i>
                    </span>

                    <div>
                      <h3>{lang.additionalSection}</h3>
                      <p>{lang.additionalDescription}</p>
                    </div>

                    <small>{lang.optional}</small>
                  </div>

                  <div className="anf-field">
                    <label htmlFor="anf-questions">
                      {lang.labels.questions}
                    </label>

                    <div className="anf-textarea-wrapper">
                      <textarea
                        id="anf-questions"
                        name="questions"
                        rows="5"
                        value={formData.questions}
                        onChange={handleChange}
                        placeholder={lang.placeholders.questions}
                        maxLength="1000"
                      ></textarea>

                      <span>
                        {formData.questions.length}/1000
                      </span>
                    </div>
                  </div>
                </section>

                <div className="anf-submit-panel">
                  <div className="anf-privacy-note">
                    <i className="bi bi-shield-check"></i>

                    <p>{lang.privacy}</p>
                  </div>

                  <button
                    type="submit"
                    className="anf-submit-button"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="anf-submit-spinner"></span>
                        {lang.submitting}
                      </>
                    ) : (
                      <>
                        {lang.submit}
                        <i className="bi bi-arrow-right"></i>
                      </>
                    )}
                  </button>
                </div>

                {(successMessage || errorMessage) && (
                  <div
                    className={`anf-status-message ${
                      successMessage ? "success" : "error"
                    }`}
                    role="alert"
                    aria-live="polite"
                  >
                    <span>
                      <i
                        className={
                          successMessage
                            ? "bi bi-check-circle-fill"
                            : "bi bi-exclamation-triangle-fill"
                        }
                      ></i>
                    </span>

                    <div>
                      <strong>
                        {successMessage
                          ? language === "en"
                            ? "Application Submitted"
                            : "अर्ज सबमिट झाला"
                          : language === "en"
                            ? "Submission Failed"
                            : "अर्ज सबमिट झाला नाही"}
                      </strong>

                      <p>
                        {successMessage || errorMessage}
                      </p>
                    </div>
                  </div>
                )}
              </form>

              <aside className="anf-help-panel">
                <div className="anf-help-card">
                  <span className="anf-help-icon">
                    <i className="bi bi-headset"></i>
                  </span>

                  <span className="anf-card-eyebrow">
                    {language === "en"
                      ? "Application Support"
                      : "अर्जासाठी मदत"}
                  </span>

                  <h3>{lang.helpTitle}</h3>
                  <p>{lang.helpText}</p>

                  <Link
                    to="/contact"
                    className="anf-secondary-button"
                  >
                    <i className="bi bi-telephone"></i>
                    {lang.contactButton}
                  </Link>
                </div>

                <div className="anf-info-card">
                  <span>
                    <i className="bi bi-lightbulb"></i>
                  </span>

                  <div>
                    <strong>
                      {language === "en"
                        ? "Before submitting"
                        : "सबमिट करण्यापूर्वी"}
                    </strong>

                    <p>
                      {language === "en"
                        ? "Review your mobile number, email, income and required loan amount carefully."
                        : "मोबाईल नंबर, ईमेल, उत्पन्न आणि आवश्यक कर्ज रक्कम काळजीपूर्वक तपासा."}
                    </p>
                  </div>
                </div>

                <div className="anf-info-card">
                  <span>
                    <i className="bi bi-clock-history"></i>
                  </span>

                  <div>
                    <strong>
                      {language === "en"
                        ? "Processing timeline"
                        : "प्रक्रियेचा कालावधी"}
                    </strong>

                    <p>
                      {language === "en"
                        ? "Timelines depend on document completeness, verification and lender assessment."
                        : "कालावधी कागदपत्रे, पडताळणी आणि बँकेच्या मूल्यांकनावर अवलंबून असतो."}
                    </p>
                  </div>
                </div>

                <div className="anf-info-card">
                  <span>
                    <i className="bi bi-lock"></i>
                  </span>

                  <div>
                    <strong>
                      {language === "en"
                        ? "Use accurate information"
                        : "योग्य माहिती भरा"}
                    </strong>

                    <p>
                      {language === "en"
                        ? "Incorrect or incomplete details may delay the application review."
                        : "चुकीची किंवा अपूर्ण माहिती अर्जाच्या तपासणीस विलंब करू शकते."}
                    </p>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </section>

        <section className="anf-disclaimer">
          <div className="anf-page-container">
            <i className="bi bi-shield-exclamation"></i>
            <p>{lang.disclaimer}</p>
          </div>
        </section>
      </main>
    </>
  );
};

export default ANF;